module.exports = __webpack_public_path__ + "static/media/ranger4wd2015.22e8906b.webp";